export default __webpack_public_path__ + "static/media/1.f4e4268a.png";